class CartRecommendationsLoader extends HTMLElement {
  connectedCallback() {
    this.fetchRecommendations();
  }

  fetchRecommendations() {
    const url = `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`;
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const content = wrapper.querySelector(`#shopify-section-${this.dataset.sectionId}`);
        if (content) {
          this.innerHTML = content.innerHTML;
          this.classList.add('recommendations--loaded');
        }
      })
      .catch(err => {
        console.error('[CartRecommendationsLoader] Failed to fetch:', err);
      });
  }
}

if (!customElements.get('cart-recommendations-loader')) {
  customElements.define('cart-recommendations-loader', CartRecommendationsLoader);
}

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    document.querySelector('cart-recommendations-loader')?.fetchRecommendations();
  });
}
